import React from "react";

interface LabourDeficitModalProps {
  isOpen: boolean;
  onClose: () => void;
  officeName: string;
  county: string;
  year: number;
  largeShortageProfessions: string[];
  shortageProfessions: string[];
}

const LabourDeficitModal: React.FC<LabourDeficitModalProps> = ({
  isOpen,
  onClose,
  officeName,
  county,
  year,
  largeShortageProfessions,
  shortageProfessions,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-4 max-w-2xl w-full mx-4 max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-start mb-3">
          <div>
            <h2 className="text-lg font-bold text-gray-900">
              Zawody z deficytem - {county}
            </h2>
            <div className="text-xs text-gray-600 mt-1">
              {officeName} • {year}
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors ml-4"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {largeShortageProfessions.length > 0 && (
          <div className="mb-4">
            <h3 className="text-sm font-semibold text-red-700 mb-2 flex items-center">
              <span className="inline-block w-2 h-2 bg-red-600 rounded-full mr-2"></span>
              Zawody z dużym deficytem ({largeShortageProfessions.length})
            </h3>
            <ul className="space-y-1">
              {largeShortageProfessions.map((profession, index) => (
                <li
                  key={index}
                  className="bg-red-50 border-l-3 border-red-400 px-2 py-1 text-sm text-left"
                >
                  {profession}
                </li>
              ))}
            </ul>
          </div>
        )}

        {shortageProfessions.length > 0 && (
          <div className="mb-4">
            <h3 className="text-sm font-semibold text-orange-700 mb-2 flex items-center">
              <span className="inline-block w-2 h-2 bg-orange-500 rounded-full mr-2"></span>
              Zawody z deficytem ({shortageProfessions.length})
            </h3>
            <ul className="space-y-1">
              {shortageProfessions.map((profession, index) => (
                <li
                  key={index}
                  className="bg-orange-50 border-l-3 border-orange-400 px-2 py-1 text-sm text-left"
                >
                  {profession}
                </li>
              ))}
            </ul>
          </div>
        )}

        {largeShortageProfessions.length === 0 &&
          shortageProfessions.length === 0 && (
            <div className="text-left py-4 text-gray-500">
              <p className="text-sm">
                Brak zawodów z deficytem w tym powiecie w {year} roku.
              </p>
            </div>
          )}

        <div className="flex justify-end pt-2">
          <button
            onClick={onClose}
            className="px-3 py-1 bg-gray-500 text-white text-sm rounded hover:bg-gray-600 transition-colors"
          >
            Zamknij
          </button>
        </div>
      </div>
    </div>
  );
};

export default LabourDeficitModal;
